"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ribbon = exports.TEST_ID_RIBBON = void 0;
var react_1 = __importDefault(require("react"));
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
exports.TEST_ID_RIBBON = "ribbon";
var outerSquare = 108;
var percentageOffset = 10;
function Ribbon(_a) {
    var text = _a.text, csx = _a.csx;
    return (react_1.default.createElement(theme_ui_1.Box, { sx: __assign({ height: outerSquare + "px", overflow: "hidden", position: "relative", width: outerSquare + "px" }, csx) },
        react_1.default.createElement(theme_ui_1.Text, { variant: "p", sx: {
                alignItems: "center",
                bg: theme_1.theme.colors.brandGreen,
                display: "flex",
                fontSize: 2,
                height: 4,
                justifyContent: "center",
                left: 50 + percentageOffset + "%",
                margin: 0,
                position: "absolute",
                top: 50 - percentageOffset + "%",
                transform: "translate(-50%, -50%) rotate(45deg)",
                width: "140%"
            }, "data-testid": exports.TEST_ID_RIBBON }, text)));
}
exports.Ribbon = Ribbon;
